//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import Typography from '@mui/material/Typography';
import styled from '@emotion/styled';
import { convertStylesToStyled } from '@/_utils/utils';

type TitleProps = {
  children: React.ReactNode;
};

const Title = ({ children }: TitleProps) => {
  return <TitleText variant="h2">{children}</TitleText>;
};

export default Title;

const TitleText = styled(Typography)`
  opacity: 0.75;
  display: flex;
  align-items: center;
  min-height: 2rem;
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 1.2rem;

  & > svg {
    margin-right: ${({ theme }) => theme.spacing(1)};
    color: ${({ theme }) => theme.palette.primary.main};
  }

  ${({ theme }) => convertStylesToStyled(theme.components?.MuiBreadcrumbs?.styleOverrides?.li)};
`;
